import { render, staticRenderFns } from "./DirectorMatchingManagement.vue?vue&type=template&id=71f57d2c&scoped=true"
import script from "./DirectorMatchingManagement.vue?vue&type=script&lang=js"
export * from "./DirectorMatchingManagement.vue?vue&type=script&lang=js"
import style0 from "./DirectorMatchingManagement.vue?vue&type=style&index=0&id=71f57d2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f57d2c",
  null
  
)

export default component.exports